module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/admissions/headshot_derrick-a3b9315c9c38a72007b1766cc95d7191.jpg";